import styled from 'styled-components'

export const GlobalSearchListItemLayoutStyled = styled.button.attrs({
  type: 'button',
})`
  display: flex;
  align-items: center;
  gap: ${(props) => props.theme.space.medium};
  width: 100%;
  padding: ${(props) =>
    `${props.theme.typography.pxToRem(12)} ${props.theme.space.medium}`};
  border: none;
  border-radius: ${(props) => props.theme.shape.borderRadius}px;
  background: transparent;
  cursor: pointer;
  text-align: left;
  font-family: inherit;

  &:hover {
    background: ${(props) => props.theme.colors.neutral};
  }

  &:focus-visible {
    outline: ${(props) => props.theme.typography.pxToRem(2)} solid
      ${(props) => props.theme.colors.primary};
    outline-offset: ${(props) => props.theme.typography.pxToRem(-2)};
  }
`
